import React from 'react';
import styles from './StepDescription.module.scss';
import posed from 'react-pose';

const TextMask = posed.div({
    enter1: {
        scaleY: 0,
        delay: props => (props.startedOnce ? 0 : 800),
        transition: {
            ease: 'linear',
        },
    },
    exit1: {
        scaleY: 1,
        transition: {
            scaleY: {type: 'keyframes', values: [1, 1], times: [0, 1]},
        },
    },
});

export default function StepDescription({children: text, visible, startedOnce}) {
    const pose = visible ? 'enter1' : 'exit1';

    return (
        <li className={styles.stepDescription}>
            <div className={styles.text}>{text}</div>
            <TextMask
                pose={pose}
                initialPose='exit1'
                startedOnce={startedOnce}
                className={styles.mask}
            />
        </li>
    );
}
